/**
 * Basic dialog implementation.
 */
import { PropsWithChildren, useCallback } from "react";
import { className as classNames } from "@/common/utils/strings";

import BackIcon from "@/common/images/icons/left_arrow.svg?react";
import CloseIcon from "./images/icons/close.svg?react";

import "./Dialog.scss";

type IDialogProps = PropsWithChildren<{
  onBack?: () => void;
  onClose?: () => void;
  title: string;
  buttons?: JSX.Element;
  className?: string;
}>;

export const Dialog = ({ onBack, onClose, title, children, buttons, className }: IDialogProps): JSX.Element => {
  const handleBack = useCallback(() => {
    onBack && onBack();
  }, [onBack]);

  const handleClose = useCallback(() => {
    onClose && onClose();
  }, [onClose]);

  return (
    <div className={classNames({
      "dialog": true,
      [className ?? ""]: true,
    })}>
      <div className="backdrop"></div>
      <div className="canvas">
        <div className="dialogHeader">
          { onBack && (
            <button className="back button" onClick={handleBack} aria-label="back button">
              <BackIcon />
            </button>
          )}

          <div className="dialogTitle">{title}</div>

          { onClose && (
            <button className="close button" onClick={handleClose} aria-label="close dialog">
              <CloseIcon />
            </button>
          )}
        </div>

        <div id="dialogContent" className="dialogContent">
          {children}
        </div>

        { buttons && (
          <div className="dialogButtons">
            {buttons}
          </div>
        )}
      </div>
    </div>
  );
};
